import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Blog_Card from "../common-components/blog_card/Blog_Card";
import Common_Banner from "../common-components/common-banner/Common_Banner";
import "./Blog.css";

const blogPosts = [
  {
    id: 1,
    date: "08 October, 2025",
    title: "5 Tips to Improve Your Stamina",
    description:
      "Boost your endurance with these easy and effective stamina-building exercises suitable for all fitness levels.",
    author: "Coach Anita",
    authorImg: "/assets/images/blog/coach.png",
    img: "/assets/images/blog/running.png",
  },
  {
    id: 2,
    date: "09 October, 2025",
    title: "Beginner’s Guide to Martial Arts",
    description:
      "Learn the basics of martial arts, from warm-up exercises to essential techniques, for self-defense and fitness.",
    author: "Siddharth Jain",
    authorImg: "/assets/images/blog/coach.png",
    img: "/assets/images/blog/martial_arts.png",
  },
  {
    id: 3,
    date: "10 October, 2025",
    title: "Top 10 Exercises for a Healthy Back",
    description:
      "Strengthen your back muscles and prevent injuries with these expert-recommended exercises.",
    author: "Priya Nair",
    authorImg: "/assets/images/blog/coach.png",
    img: "/assets/images/blog/yoga.png",
  },
  {
    id: 4,
    date: "08 October, 2025",
    title: "5 Tips to Improve Your Stamina",
    description:
      "Boost your endurance with these easy and effective stamina-building exercises suitable for all fitness levels.",
    author: "Coach Anita",
    authorImg: "/assets/images/blog/coach.png",
    img: "/assets/images/blog/running.png",
  },
  {
    id: 5,
    date: "09 October, 2025",
    title: "Beginner’s Guide to Martial Arts",
    description:
      "Learn the basics of martial arts, from warm-up exercises to essential techniques, for self-defense and fitness.",
    author: "Siddharth Jain",
    authorImg: "/assets/images/blog/coach.png",
    img: "/assets/images/blog/martial_arts.png",
  },
  {
    id: 6,
    date: "10 October, 2025",
    title: "Top 10 Exercises for a Healthy Back",
    description:
      "Strengthen your back muscles and prevent injuries with these expert-recommended exercises.",
    author: "Priya Nair",
    authorImg: "/assets/images/blog/coach.png",
    img: "/assets/images/blog/yoga.png",
  },
  {
    id: 7,
    date: "08 October, 2025",
    title: "5 Tips to Improve Your Stamina",
    description:
      "Boost your endurance with these easy and effective stamina-building exercises suitable for all fitness levels.",
    author: "Coach Anita",
    authorImg: "/assets/images/blog/coach.png",
    img: "/assets/images/blog/running.png",
  },
  {
    id: 8,
    date: "09 October, 2025",
    title: "Beginner’s Guide to Martial Arts",
    description:
      "Learn the basics of martial arts, from warm-up exercises to essential techniques, for self-defense and fitness.",
    author: "Siddharth Jain",
    authorImg: "/assets/images/blog/coach.png",
    img: "/assets/images/blog/martial_arts.png",
  },
  {
    id: 9,
    date: "10 October, 2025",
    title: "Top 10 Exercises for a Healthy Back",
    description:
      "Strengthen your back muscles and prevent injuries with these expert-recommended exercises.",
    author: "Priya Nair",
    authorImg: "/assets/images/blog/coach.png",
    img: "/assets/images/blog/yoga.png",
  },
];

const Blog = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "BLOGS", link: "", isActive: true },
  ];

  const handleBlogClick = (id) => {
    navigate(`/blogs/${id}`);
  };

  return (
    <>
      <Common_Banner
        imgSrc={"/assets/images/common_banners/blogs_banner.png"}
        title_text="Blogs"
        breadcrumbs={breadcrumbs}
      />

      <section className="blog">
        <Container>
          <Row>
            {blogPosts.map((post) => (
              <Col key={post.id} md={4} sm={6} xs={12}>
                <Blog_Card
                  img={post.img}
                  title={post.title}
                  authorImg={post.authorImg}
                  author={post.author}
                  date={post.date}
                  description={post.description}
                  id={post.id}
                />
              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Blog;
